import { FieldSettings, TextFilter } from '@progress/kendo-react-data-tools'
import { IntroducingBrokerProfileFilterKey } from 'api/Trading-Accounts/Types/IntroducingBrokerProfileDto'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

import { CompaniesFilter } from './common.filter'

const getIntroducingBrokerProfileFilterFields = (): FieldSettings[] => [
  {
    name: IntroducingBrokerProfileFilterKey.name,
    label: 'Name',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.likeOperator,
        operator: GridFilterOperatorEnum.likeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notLikeOperator,
        operator: GridFilterOperatorEnum.notLikeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.startsWithOperator,
        operator: GridFilterOperatorEnum.startsWithOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notStartsWithOperator,
        operator: GridFilterOperatorEnum.notStartsWithOperator,
      },
    ],
  },
  {
    name: IntroducingBrokerProfileFilterKey.tickmillCompany,
    label: 'Company',
    filter: CompaniesFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
]

export { getIntroducingBrokerProfileFilterFields }
